import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Terms } from './pages/Terms';
import { Services } from './pages/Services';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
      <Routes data-id="element-6">
        <Route path="/" element={<App data-id="element-8" />} data-id="element-7" />
        <Route path="/terms" element={<Terms data-id="element-10" />} data-id="element-9" />
        <Route path="/services" element={<Services data-id="element-12" />} data-id="element-11" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-14" />} data-id="element-13" />
      </Routes>
    </BrowserRouter>;
}